export const calculateMultiTripQuery = `mutation CalculateMultiTripTravel (
    $request: MultiTripTravel_CalculationRequestInput!
) {
    calculateMultiTripTravel(input: {request: $request}) {
        multiTripTravel_CalculationResult {
            policyPolicyDetails {
                clauses {
                    clauseExplanation
                    clauseName
                    clauseNumber
                }
                coverageCancellations {
                    productDescription
                    petIllnessDeathAdditionallyInsured
                    businessTravelAdditionallyInsured
                }
                coverageTravels {
                    additionalInsuredAmountBicycle
                    additionalInsuredAmountLuggage
                    adventurousSportsAdditionallyInsured
                    alternativeTransportAdditionallyInsured
                    assistanceExcludingRoadsideAdditionallyInsured
                    businessAgentAdditionallyInsured
                    businessTravelAdditionallyInsured
                    cancellationAdditionallyInsured
                    carrierCoverageCode
                    compositeTripAdditionallyInsured
                    costsInstallmentAmount
                    costsMedicalTreatmentAdditionallyInsured
                    coverageAreaCode
                    dangerousSportsAdditionallyInsured
                    deductibleAmount
                    deductibleAmountLuggage
                    discountsInstallmentAmount
                    divingEquipmentAdditionallyInsured
                    exceptionalCostsAdditionallyInsured
                    extendedStayAdditionallyInsured
                    extraAmountDivingEquipmentAdditionallyInsured
                    extraAmountGolfEquipmentAdditionallyInsured
                    grossPremiumInstallment
                    injuryAdditionallyInsured
                    insuranceTaxInstallmentAmount
                    insuredAmountDemise
                    insuredAmountMoneyChecks
                    insuredAmountTravelCancellation
                    insuredAmountTravelLuggage
                    insuredAmountUnderwaterSportsEquipment
                    insuredFamilyComposition
                    legalAidAdditionallyInsured
                    luggageAdditionallyInsured
                    medicalCostsAdditionallyInsured
                    moneyChequesAdditionallyInsured
                    netPremiumInstallment
                    numberOfDaysCoverage
                    numberOfInsuredCaravans
                    numberOfInsuredMotorVehicles
                    numberOfInsuredTrailers
                    partnerAdditionallyInsured
                    permanentDisabilityInsuredAmount
                    productDescription
                    refKey
                    repatriationCostsAdditionallyInsured
                    returnCommissionPercentage
                    roadsideAssistanceAdditionallyInsured
                    skiingSnowboardingAdditionallyInsured
                    sportsEquipmentAdditionallyInsured
                    sumInsured
                    surchargesInstallmentAmount
                    totalInstallmentAmount
                    underwaterSportsAdditionallyInsured
                    winterSportsAdditionallyInsured
                }
                coverageBreakdownAssistances {
                    productDescription
                }
                coverageLegalCounsels {
                    productDescription
                }
                documents {
                    attachmentDescription
                    attachmentType
                    urlAttachment
                }
                conditionConditionDetails {
                    conditionText
                    conditionNumber
                    documents {
                        attachmentDescription
                        attachmentType
                        urlAttachment
                    }
                }
                underwritingCompanySpecifics {
                    underwritingResult
                }
                refKey
                effectiveDate
                externalSourceName
                productCode
                productDescription
                companyNameDescription
                marketingName
                oneOffCostsAmount
                porCompany
                contractNumber
                paymentTermInMonths
                customProperties {
                    supplierKrn
                }
                costsInstallmentAmount
                discountsInstallmentAmount
                grossPremiumInstallment
                insuranceTaxInstallmentAmount
                surchargesInstallmentAmount
                totalInstallmentAmount
                netPremiumInstallment
                expectedAcquisitionCommissionPartnerAmount
            }
            commonTechnical {
                transactionReference
                accessCode
            }
        }
        errors {
            ... on MultiTripTravel_IGraphQlErrorBase {
                type
                message
            }
        }
    }
}
`;
